import argentinaImg from '../assets/options/argentina.png';
import capeVerdeImg from '../assets/options/cape-verde.png';

/**
 * VoteNations map battle option images used as territory fills (MapPatternDefs).
 * MLV (Islas Malvinas) uses argentina.png on voting maps — never FK/Falklands.
 */
const OPTION_FLAG_BY_ENTITY = {
  ARG: argentinaImg,
  MLV: argentinaImg,
  CPV: capeVerdeImg,
};

const bundledFlagSvgs = import.meta.glob('../assets/flags/*.svg', {
  eager: true,
  query: '?url',
  import: 'default',
});

/** @returns {string | null} Bundled URL for an entity's flag image (PNG or SVG). */
export function getEntityFlagUrl(entityCode) {
  if (!entityCode) return null;

  if (OPTION_FLAG_BY_ENTITY[entityCode]) {
    return OPTION_FLAG_BY_ENTITY[entityCode];
  }

  return bundledFlagSvgs[`../assets/flags/${entityCode}.svg`] ?? null;
}

export { argentinaImg, capeVerdeImg };
